const API_KEY = process.env.REACT_APP_AWS_FRIENDZ_API_KEY;
const API_BASE_URL = 'https://albvg9jakf.execute-api.us-east-1.amazonaws.com/test';

export const saveUserPropertyData = async (userId, propertyAddress, propertyData) => {
  const url = `${API_BASE_URL}/save-user-property-data`;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY
    },
    body: JSON.stringify({
      userId,
      propertyAddress,
      propertyData
    })
  };

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        const errorText = await response.text();
        errorData = { error: errorText };
      }
      
      throw new Error(errorData.error || `Network response was not ok: ${response.status}`);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error saving property data:', error);
    throw error;
  }
};